import { render } from "./impressionsCard.vue?vue&type=template&id=44e79af2&scoped=true"
import script from "./impressionsCard.vue?vue&type=script&lang=js"
export * from "./impressionsCard.vue?vue&type=script&lang=js"

import "./impressionsCard.vue?vue&type=style&index=0&id=44e79af2&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44e79af2"]])

export default __exports__